export const miscAttributesMap = [
	'otherinformation',
	'frontloadermake',
	'fronttyresize',
	'reartyresize',
	'topspeed',
	'hydraulicsoutput',
	'numberofvalves',
	'internalstocknumber',
	'manufacturenumber',
	'transmission',
	'meterreadouthours',
	'enginemanufacturer',
	'engineoutput',
	'cylinders',
	'tractiontype',
	'tractortype',
	'productioncountry',
	'harvesterdriveconfiguration',
	'antique',
	'workingwidth',
	'transportweight',
	'enginedisplacement',
	'separatormeterreadouthours',
	'areaharvested',
	'machinetype',
	'balecount',
	'inspectiongrade',
	'usagetype',
	'previousownercount',
	'mowerequipment',
	'trucktype',
	'enginetype',
	'transmissiontype',
	'cuttertype',
	'cuttingunits',
	'cuttingunit',
	'cuttingmethod',
	'liftheight',
	'forklength',
	'batterycapacity',
	'bodytype',
	'axestype',
	'manufacturer',
	'maxpayload',
	'grossweight',
	'cargospacedimensions',
	'fronttyrecondition',
	'reartyrecondition',
	'emissionlevel',
	'trackwidth',
	'engine',
	'enginecondition',
	'damaged',
	'pumppowertype',
	'pipediameter',
	'pumppower',
	'transportdimensions',
	'guarantee',
	'loadcapacity',
	'brakes',
	'suspensiontype',
	'bodyworktype',
	'outerdimensions',
	'tyrebrand',
	'colour',
	'servicecontract',
	'inspectiondate',
	'registrationnumber',
	'palletcapacity',
	'wheelbase',
	'knivesperauger',
	'meterreadoutkilometers'
]

// This is defined twice, changes needs to be done MascusFetcher.php and map.js
export const filterCategoriesMap = [
	{
		text: 'Traktorer',
		contains: ['tractors']
	},
	{
		text: 'Skördetröskor',
		contains: ['combineharvesters']
	},
	{
		text: 'Vallskörd',
		contains: ['rakes', 'roundbalers', 'windrowers', 'mowers', 'squarebalers', 'otherforageequipment', 'moverconditioners', 'toppers']
	},
	{
		text: 'Redskap',
		contains: ['agriculturefrontloaderaccessories', 'multipurposeloaders']
	},
	{
		text: 'Vagnar',
		contains: ['agriothertrailers', 'agritippertrailers', 'agrigeneraltrailers']
	},
	{
		text: 'Jordbearbetning',
		contains: ['discharrows', 'cultivators', 'agrirollers', 'harrows', 'reversibleploughs']
	},
	{
		text: 'Mineral- och stallgödselspridare',
		contains: ['mineralspreaders', 'slurrytankers', 'pumps']
	},
	{
		text: 'Tillbehör',
		contains: ['agriculturedualwheels']
	},
	{
		text: 'Maskiner för sådd och sättning',
		contains: ['agridrills', 'agricombinationdrills']
	},
	{
		text: 'Inomgårdsutrustning',
		contains: ['baleshredders']
	},
	{
		text: 'Maskiner för väg och snö',
		contains: ['sandspreaders', 'roaddrags', 'snowblades', 'snowgroomers']
	},
	{
		text: 'Terränghjulingar och skotrar',
		contains: ['atvs', 'utvs']
	},
	{
		text: 'Häck-klippare',
		contains: ['hedgecutters']
	},
	{
		text: 'Reservdelar',
		contains: ['agriculturewheels']
	},
	{
		text: 'Potatisodlingsutrustning',
		contains: ['potatoplanters']
	},
	{
		text: 'Gräsklippare',
		contains: ['ridingmowers', 'walkbehindmowers']
	},
	{
		text: 'Sopmaskiner',
		contains: ['sweepers']
	},
	{
		text: 'Redskapsbärare',
		contains: ['utilitymachines']
	},
	{
		text: 'Golf- och sport grönytemaskiner',
		contains: ['blowers']
	},
	{
		text: 'Övriga grönytemaskiner',
		contains: ['othergroundscaremachines']
	},
	{
		text: 'Grävmaskiner',
		contains: ['miniexcavators', 'midiexcavators']
	},
	{
		text: 'Redskap och utrustning',
		contains: ['constructionbuckets']
	},
	{
		text: 'Trähantering',
		contains: ['stumpgrinders']
	},
	{
		text: 'Staplare',
		contains: ['selfpropelledstackers']
	},
	{
		text: 'Tillbehör och komponenter',
		contains: ['materialhandlingothercomponents']
	},
	{
		text: 'Släpvagnar',
		contains: ['flatbedtrailers', 'lighttrailers', 'tippertrailers']
	},
	{
		text: 'Påhängsvagnar',
		contains: ['semimisctrailers']
	},
	{
		text: 'Elektriska fordon',
		contains: ['electricvehicles']
	},
	{
		text: 'Grönyte-maskiner',
		contains: []
	},
]
